import { Line } from "@react-three/drei";
import { PATH_POINTS } from "./poi";

export default function FloorPath() {
  return (
    <group>
      <Line points={PATH_POINTS} color="#01FFFF" lineWidth={2} transparent opacity={0.55} />
      <Line
        points={PATH_POINTS}
        color="#FF007F"
        lineWidth={5}
        transparent
        opacity={0.12}
      />
    </group>
  );
}
